import React from 'react';
import TeachersContainer from './styles';
import { useTranslation } from 'react-i18next';
import { teacherStaff } from '../../../../../utils';
import Teacher from '../../../../../components/Cards/Teacher';

const Teachers = () => {
	const { t } = useTranslation();
	const getStaff = () => {
		return teacherStaff.map((teacher, idx) => (
			<Teacher
				key={idx}
				name={t(teacher.name)}
				label={t(teacher.label)}
				descriptions={teacher.descriptions}
				image={teacher.image}
				imagePosition={teacher.imagePosition}
				imageSize={teacher.imageSize}
			/>
		));
	};
	return <TeachersContainer>{getStaff()}</TeachersContainer>;
};

export default Teachers;
